import { render, staticRenderFns } from "./activityBannerNew.vue?vue&type=template&id=35f796da&scoped=true"
import script from "./activityBannerNew.vue?vue&type=script&lang=js"
export * from "./activityBannerNew.vue?vue&type=script&lang=js"
import style0 from "./activityBannerNew.vue?vue&type=style&index=0&id=35f796da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f796da",
  null
  
)

export default component.exports